import { ExistingProducerData } from '@/features/serviceModal/components/LinkProducerModal/components/ExistingProducerItem/types';
import { LinkProducerModalSteps } from '@/features/serviceModal/components/LinkProducerModal/enums';
import { LinkEntityTypesEnum } from '../../enums/LinkEntityTypesEnum';

export type SearchExistingProducerStep = {
  selectedProducerGroupId: number | null;
  selectedProducerId: number | null;
};

export type SearchExistingAgentStep = {
  selectedProducerId: number | null;
};

export type LinkProducerStepsState = {
  [LinkProducerModalSteps.SearchExistingProducer]: SearchExistingProducerStep;
  [LinkProducerModalSteps.SearchExistingAgent]: SearchExistingAgentStep;
};

export type LinkProducerStatusesState = {
  isLinkProducerLoading: boolean;
};

export type LinkProducerState = {
  linkProducerType: LinkEntityTypesEnum;
  linkProducerSteps: LinkProducerStepsState;
  userForProducerLink: ExistingProducerData | null;
  usersListForProducerLink: ExistingProducerData[] | null;
  statuses: LinkProducerStatusesState;
};

export const linkProducerInitialState: LinkProducerState = {
  linkProducerType: LinkEntityTypesEnum.AUTO,
  linkProducerSteps: {
    [LinkProducerModalSteps.SearchExistingProducer]: {
      selectedProducerGroupId: null,
      selectedProducerId: null,
    },
    [LinkProducerModalSteps.SearchExistingAgent]: {
      selectedProducerId: null,
    },
  },
  userForProducerLink: null,
  usersListForProducerLink: null,
  statuses: {
    isLinkProducerLoading: false,
  },
};

export type LinkProducerFieldKey = keyof LinkProducerStepsState;
export type LinkProducerFieldValue<K extends LinkProducerFieldKey> = LinkProducerStepsState[K];
